import { jsxs, jsx } from "react/jsx-runtime";
import React__default from "react";
class ErrorBoundary extends React__default.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error, errorInfo) {
    console.log("Error: ", error);
    console.log("Error Info:", errorInfo);
  }
  render() {
    const {
      hasError
    } = this.state;
    const {
      children
    } = this.props;
    if (hasError) {
      return /* @__PURE__ */ jsxs("section", { children: [
        /* @__PURE__ */ jsx("h1", { className: "sezzle-gray center", children: "Oh no! Something happened." }),
        /* @__PURE__ */ jsxs("p", { className: "subtitle-medium dark-gray center m-bot-200 m-top-100", children: [
          "Go to ",
          /* @__PURE__ */ jsx("a", { className: "szl-link", href: "https://sezzle.com", children: "Sezzle homepage." })
        ] })
      ] });
    }
    return children;
  }
}
export {
  ErrorBoundary as default
};
//# sourceMappingURL=ErrorBoundary.js.map
